import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/V3/Button'

import EmptyStateIcon from '../EmptyState/icons/EmptyStateIcon'

/* Same frame as the empty state, so the two read as siblings; the illustration is
   desaturated because nothing here is an invitation. */
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: calc(100vh - 387px);

  /* New nav: the shell (top bar, global banner, page inset) replaces the legacy 64px header. */
  .platform-nav-content & {
    min-height: calc(
      100vh - var(--top-bar-height, 52px) - var(--banner-height, 0px) -
        (var(--page-inset, 20px) * 2) - 350px
    );
  }
  padding: var(--t-spacing-8) 0;
`

const Illustration = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  filter: grayscale(1);
  opacity: 0.7;
`

const Title = styled.div`
  margin: var(--t-spacing-4) 0 var(--t-spacing-2);
  font-size: var(--t-typography-font-size-base);
  font-weight: var(--t-typography-font-weight-semi-bold);
  color: var(--color-text);
`

const Description = styled.div`
  max-width: 560px;
  margin-bottom: var(--t-spacing-6);
  font-size: var(--t-typography-font-size-xs);
  line-height: var(--t-typography-line-height-xs);
  color: var(--sub-text-color);
`

const ListErrorState = ({ onRetry }) => (
  <Container data-testid="Psima_Launched_ListError_div">
    <Illustration>
      <EmptyStateIcon />
    </Illustration>
    <Title>Couldn&apos;t load simulations</Title>
    <Description>
      Check your connection and try again.
      <br />
      If it keeps happening, our support team can help.
    </Description>
    <Button
      id="Psima_Launched_Retry_Button"
      dataTestId="Psima_Launched_Retry_Button"
      variant="secondary"
      size="medium"
      onClick={onRetry}
    >
      Try again
    </Button>
  </Container>
)

export default ListErrorState
